import React from "react";

import Heading from "@common/components/Heading/Heading";
import Paragraph from "@common/components/Paragraph/Paragraph";
import * as MetricDetailsStyled from "main/pages/Release/views/MetricDetails/MetricDetails.styles";

export default function ResolutionRateAboutView() {
  return (
    <div style={{ padding: "3.2rem 0" }}>
      <MetricDetailsStyled.MetricsCard>
        <Heading
          heading3
          marginBottom={24}
        >
          About
        </Heading>
        <Heading
          heading4
          marginBottom={16}
          fontWeight={"bold"}
        >
          What it measures
        </Heading>
        <Paragraph
          p1
          marginBottom={24}
        >
          {
            "The ratio of defect points your team closes vs. defect points newly created in the release window. Each defect's points depend on its priority (configurable on the Score tab)."
          }
        </Paragraph>

        <Heading
          heading4
          marginBottom={16}
          fontWeight={"bold"}
        >
          Why it matters
        </Heading>
        <Paragraph
          p1
          marginBottom={24}
        >
          {
            "A release is only as healthy as the trajectory of its defect backlog. Shipping a clean build while letting bugs pile up is borrowing against the next release. Resolution rate is a leading indicator of long-term release quality and team velocity."
          }
        </Paragraph>

        <Heading
          heading4
          marginBottom={16}
          fontWeight={"bold"}
        >
          How to use it
        </Heading>
        <Paragraph
          p1
          marginBottom={24}
        >
          {
            "100% means you're keeping pace with incoming defects; above 100% means you're paying down the backlog. If the score is low, check whether one priority bucket is being neglected — high-priority items piling up is a very different problem from low-priority noise accumulating."
          }
        </Paragraph>
      </MetricDetailsStyled.MetricsCard>
    </div>
  );
}
